import { useResponsive } from "@design-lab/shared/hooks/useResponsive";
import { useTab } from "@design-lab/entities/transfers-lab/model/useTab";
import { TransfersLabDesktop } from "./TransfersLabDesktop";

export function TransfersLabPage() {
  const { isDesktop } = useResponsive();
  const { tab, tabs, setTab } = useTab();

  if (isDesktop) {
    return <TransfersLabDesktop tabs={tabs} tab={tab} handleTabClick={setTab} />;
  }

  return null;
}
